import { render, staticRenderFns } from "./CreateBorrowOrder.vue?vue&type=template&id=3b537177&scoped=true&"
import script from "./CreateBorrowOrder.vue?vue&type=script&lang=js&"
export * from "./CreateBorrowOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateBorrowOrder.vue?vue&type=style&index=0&id=3b537177&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b537177",
  null
  
)

export default component.exports